// @flow

import { SearchSimilarLink } from 'src/Domain/Fallback/SearchSimilarLink';
import { Unavailable } from 'src/Domain/Unavailable';

import type { ResultItem } from '../types';

import { UntransferableReason } from './UntransferableReason';
import {
  getDomainPossibility,
  transferPossibility2AvailabilityIconName,
  useAvailabilityText,
} from './modules';

type Props = { result: ResultItem };

export function UnavailableRow({ result }: Props): React.MixedElement {
  const availabilityText = useAvailabilityText({ domain: result });

  const possibility = getDomainPossibility(result);
  const availabilityIconName =
    transferPossibility2AvailabilityIconName[possibility];

  return (
    <Unavailable
      availabilityIconName={availabilityIconName}
      availabilityText={availabilityText}
      fqdn={result.fqdn}
    >
      {possibility === 'none' && <SearchSimilarLink term={result.fqdn} />}
      {possibility === 'untransferable' && !!result.availabilityMsg && (
        <UntransferableReason
          fqdn={result.fqdn}
          reason={result.availabilityMsg}
        />
      )}
    </Unavailable>
  );
}

UnavailableRow.Error = function UnavailableRowError({
  fqdn,
}: {
  fqdn: string,
}): React.MixedElement {
  return <Unavailable.Error fqdn={fqdn} />;
};
